module.exports = __webpack_public_path__ + "media/images/views/lp/home/features/client-a03829288651de0939fb22a6bb7ca428.png";